import { OutlinedInput, styled } from '@mui/material';
import SearchIcon from '../Icons/SearchIcon';

const SearchTextField = styled(OutlinedInput)({
  height: '37px',
  minWidth: '280px',
  border: '1px solid #EAEAEA',
  backgroundColor: '#F8F8F8',
  fontFamily: 'Manrope',
  fontSize: 12,
  borderRadius: 4,
  '& svg': {
    opacity: 0.5,
    width: '18px',
    height: '18px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
});

const SearchInput = props => {
  return <SearchTextField startAdornment={<SearchIcon />} {...props} />;
};

export default SearchInput;
